import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import capitalize from 'lodash/capitalize';
import isEmpty from 'lodash/isEmpty';
import { messagesActions } from '../Messages';
import { CUSTOM_OPTIONS_FORM_ID, CUSTOM_OPTIONS_FORM } from './CustomOptions.config';
import { isRequired, matchesRegExp, isInBetween } from '../../validation';

const validateIsRequired = (
    dataItem = {},
    personalizedItemType = false,
    optionName = '',
    CustomOptionsMessages = {},
    value = ''
) => {
    if (dataItem.required) {
        const errors = isRequired(
            personalizedItemType
                ? CustomOptionsMessages.personailzedRequiredMessage
                : CustomOptionsMessages.optionRequiredMessage.replace('$1', capitalize(optionName))
        )(value);
        if (!isEmpty(errors)) return { ...errors };
    }
    return {};
};

const validateCustomOptions = (
    dataItem = {},
    personalizedItemType = false,
    optionName = '',
    CustomOptionsMessages = {},
    value = ''
) => {
    if (dataItem.required && !value) {
        return validateIsRequired(
            dataItem,
            personalizedItemType,
            optionName,
            CustomOptionsMessages,
            value
        );
    }
    if (dataItem.rules && dataItem.rules[0].regularExpression) {
        const errors = matchesRegExp(
            CustomOptionsMessages.optionInvalidMessage.replace('$1', capitalize(optionName)),
            dataItem.rules[0].regularExpression
        )(value);
        if (!isEmpty(errors)) return { ...errors };
    }
    if (dataItem.maxValue && dataItem.minValue) {
        const errors = isInBetween(
            CustomOptionsMessages.optionInvalidMessage.replace('$1', capitalize(optionName)),
            dataItem.minValue,
            dataItem.maxValue
        )(value);
        if (!isEmpty(errors)) return { ...errors };
    }
    return {};
};

export const useCustomOptionValidation = (param, value) => {
    const dispatch = useDispatch();
    const [formError, setFormError] = useState({});
    const getValidationResult = () => {
        const {
            isMTM = false,
            disableFraction = () => '',
            dataItem = {},
            personalizedItemType = false,
            optionName = '',
            CustomOptionsMessages = {},
            validationType,
        } = param;
        const result = validateCustomOptions(
            dataItem,
            personalizedItemType,
            optionName,
            CustomOptionsMessages,
            value
        );
        if (isEmpty(result)) {
            dispatch(
                messagesActions.removeMessage({
                    id: `${CUSTOM_OPTIONS_FORM_ID}_${dataItem.id}`,
                    section: CUSTOM_OPTIONS_FORM,
                    sourceMiniPDP: false,
                })
            );
        } else {
            dispatch(
                messagesActions.addMessage({
                    section: CUSTOM_OPTIONS_FORM,
                    message: {
                        id: `${CUSTOM_OPTIONS_FORM_ID}_${dataItem.id}`,
                        title: result.title,
                        type: result.type,
                    },
                    sourceMiniPDP: false,
                })
            );
        }
        if (isMTM && validationType === 'input') {
            value >= dataItem.maxValue
                ? disableFraction(dataItem.type, true)
                : disableFraction(dataItem.type, false);
        }
        setFormError(result);
    };
    useEffect(() => {
        getValidationResult();
    }, []);
    useEffect(() => {
        getValidationResult();
    }, [value, param?.dataItem?.id]);

    return formError;
};

export default useCustomOptionValidation;
